import React from 'react';
import UnknownDumbView from '../../../../DeviationViews/Dumbo/Unknown';
import s from './Unknown.scss';
var UnknownMonoReactView = function (props) {
    return (React.createElement("div", { className: s['root'] },
        React.createElement(UnknownDumbView, { width: 350, height: 313, deviation: props.deviation })));
};
UnknownMonoReactView.displayName = 'UnknownMonoReactView';
export default UnknownMonoReactView;
//# sourceMappingURL=Unknown.js.map